/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'browser-buttons': {
    width: 42,
    height: 11,
    viewBox: '0 0 42 11',
    data: '<g _fill="none" fill-rule="evenodd" _stroke="#979797" transform="translate(1 1)"><circle pid="0" cx="4.5" cy="4.5" r="4.5" _fill="#FF6159" stroke-opacity=".134"/><circle pid="1" cx="19.5" cy="4.5" r="4.5" _fill="#FFC12F" stroke-opacity=".141"/><circle pid="2" cx="35.5" cy="4.5" r="4.5" _fill="#2ACD42" stroke-opacity=".169"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/compiled-icons/browser-buttons.js